import React from 'react';
import { observer } from 'mobx-react';
import { DatePicker, DatePickerProps } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import { IFilterParams } from '../../../interfaces';
import { useUiViewInfo } from '../../../hooks';
import { tI } from '../../../translate';
import { Catcher } from '../../Catcher';
import Styles from '../m_styles.less';

type IFilterDateMonth = {
    filterParams?: IFilterParams;
    labelSpacing?: number | string;
    onChange?: (date?: Dayjs) => void;
};

export const FilterDateMonth: React.FC<IFilterDateMonth> = observer(
    ({ filterParams, labelSpacing = 0, onChange }: IFilterDateMonth) => {
        const { date } = useUiViewInfo();
        const dateMonth = filterParams?.dateMonth;

        if (!dateMonth) {
            return null;
        }

        const onChangeDatePicker: DatePickerProps['onChange'] = (date) => {
            onChange && onChange(date ? date : undefined);
        };

        const disabledDateForMonth: RangePickerProps['disabledDate'] = (current: Dayjs): boolean => {
            return (
                current &&
                (current <
                    dayjs()
                        .add(dateMonth?.[0] * -1, 'month')
                        .startOf('month') ||
                    current > dayjs().add(dateMonth?.[1], 'month').endOf('month'))
            );
        };

        return (
            <Catcher>
                <div className={Styles.labelFieldPrefix} style={{ padding: labelSpacing }}>
                    {tI('Date Filter')}
                </div>
                <DatePicker
                    value={date}
                    disabledDate={disabledDateForMonth}
                    onChange={onChangeDatePicker}
                    picker="month"
                />
            </Catcher>
        );
    },
);
